/**
 * This file was auto-generated by client-types.
 * Do not make direct changes to this file.
 */

import * as t from 'ts-schema';
export const errorDetailSchema = t.object({
  code: t.optional(t.string),
  in: t.optional(t.string),
  message: t.string,
  subCategory: t.optional(t.string),
  context: t.optional(t.record(t.string, t.array(t.string)))
});
export const errorSchema = t.object({
  category: t.string,
  correlationId: t.string,
  message: t.string,
  subCategory: t.optional(t.string),
  context: t.optional(t.record(t.string, t.array(t.string))),
  errors: t.optional(t.array(errorDetailSchema)),
  links: t.optional(t.record(t.string, t.string))
});
export const growthFeatureSchema = t.object({
  displayName: t.string,
  featureId: t.number,
  hideFromLang: t.optional(t.string),
  isLive: t.boolean,
  shortName: t.string,
  featureCategory: t.union(t.literal('UNCATEGORIZED'), t.literal('LIMIT_INCREASE'), t.literal('REMOVE_BRANDING')),
  freeUserAccessLevel: t.union(t.literal('NO_ACCESS'), t.literal('LIMITED_ACCESS'), t.literal('FULL_ACCESS')),
  productApiNames: t.array(t.string)
});

/** get-/feature/store/v1/features/by-feature-name/{featureName} <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:FeaturesResource+type:symbol+getGrowthFeatureByName&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Features-get-%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-feature-name%2F%7BfeatureName%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ffeature%2Fstore%2Fv1%2Ffeatures%2Fby-feature-name%2F%28%28%7BfeatureName%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span> */
export const getGrowthFeatureByNameResponseSchema = growthFeatureSchema;
export const getGrowthFeatureByNameFailureSchema = errorSchema;